import { observer } from 'mobx-react-lite'
import { Radio, type RadioProps } from '@/components/inputs/Radio'
import type { FilterProps } from '@/infra/type-utils'
import {
  type ContainerProps,
  useFormFieldContainer,
} from '@/components/FormContainer'
import { FormField, FormFieldHint } from '@/components/Form'
import {
  SelectionLabel,
  SelectionLabelControl,
  SelectionLabelText,
} from './SelectionLabel'
import { action } from 'mobx'

/**
 * Form field container for a {@link Radio}.
 */
export const RadioContainer = observer(function CheckboxContainer<
  M extends object,
  K extends keyof FilterProps<M, string>,
>({
  name,
  value,
  model,
  label,
  hint,
  field,
  error,
  ...rest
}: ContainerProps<M, string, K, Omit<RadioProps, 'checked' | 'onChange'>>) {
  const { controlProps, hintProps, hintContent, labelProps } =
    useFormFieldContainer({
      name,
      model,
      field,
      hint,
      error,
    })

  return (
    <FormField>
      <SelectionLabel {...labelProps}>
        <SelectionLabelControl>
          <Radio
            {...controlProps}
            {...rest}
            value={value}
            checked={model[field] === value}
            onChange={action(`change ${field}`, (value) => {
              model[field] = value as M[K]
            })}
          />
        </SelectionLabelControl>
        <SelectionLabelText>{label}</SelectionLabelText>
      </SelectionLabel>
      <FormFieldHint {...hintProps}>{hintContent}</FormFieldHint>
    </FormField>
  )
})
